<template>
  <div>
    <div id="id-cat-fracc-sinoj" class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <input list="dataList-fraccionamientos-SINOJ" :disabled="deshabilitarInput" id="ip-txt-fracc" class="custom-select custom-select-sm">
      <datalist  id="dataList-fraccionamientos-SINOJ">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un fraccionamiento</option>
        <!-- <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todas.Nombre}} los fraccionamientos</option> -->
        <option v-for="(fraccionamiento, index) in fraccionamientos" 
          :value="fraccionamiento.Nombre" :key="'K-FRACC-' + index"
          :id="fraccionamiento.FraccionamientoId"></option>
      </datalist >
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        fraccionamientos: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      guardarBusquedaEnLocalStorage: {
        type: Boolean,
        default: false
      },
      deshabilitarInput: {
        type: Boolean,
        default: false
      },
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }

      this.$store.dispatch("A_SINOJ_Catalogos_establecer019Fraccionamientos", parametros);
    },
    methods: {
      cargaCatalogoDeFraccionamientos: function() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba

        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);

        axios.post(api.conexion + api.SINOJ.catalogos.C019Fracionamientos, this.parametros, headerPeticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.fraccionamientos = respuesta.data.Fraccionamientos;
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) { debugger
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }

        this.$store.dispatch("A_SINOJ_Catalogos_establecer019Fraccionamientos", parametros);
        let fraccionamientoConCampos = this.obtenerFraccionamientoObj(evento.target.value);
        this.$emit("valorParaElPadre", evento,fraccionamientoConCampos);   
      },
      obtenerFraccionamientoObj: function(fraccionamientoId) {
        let id = parseInt(fraccionamientoId);
        let fraccionamiento = null;
        this.fraccionamientos.filter(fBD => fBD.FraccionamientoId == id).forEach(f => {fraccionamiento = f});
        return fraccionamiento;
      },
      obtenerTodosLosFraccionamientosBD: async function({ peticion, conMensajeDeRespuesta = false }) { 
            let procesoSinError = false;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SINOJ.catalogos.C019Fracionamientos;
                const URL_API_SERVICIO = SERVIDOR + METODO_API_OBTENER;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                const HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(URL_API_SERVICIO, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Fraccionamientos, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                } 
                else { 
                    this.$store.dispatch("A_SINOJ_establecerSINOJ_Fraccionamientos_LocalStorage", Fraccionamientos);
                    this.fraccionamientos = Fraccionamientos;
                    procesoSinError = true;
                    if(conMensajeDeRespuesta)
                        comun.mensajeDeAlerta(Satisfactorio);
                }
                comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoSinError;
        },
        funcionConmutadoraDeEventos: function(fraccionamientoSeleccionado) { debugger
          let eventoPersonalizado = this.fraccionamientos.find(f => f.Nombre == fraccionamientoSeleccionado.Nombre);
          this.cambiarDatos({ target: { value: (eventoPersonalizado != null && eventoPersonalizado != undefined) ? eventoPersonalizado.FraccionamientoId : -1 } });
        },
        seleccionado: function(e){ debugger
            console.log("source = "+" new value = "+e.target.value);
            let fraccionamientoSeleccionado = { Nombre: e.target.value };
            this.funcionConmutadoraDeEventos(fraccionamientoSeleccionado);
        }
    },
    mounted() {
      $("#ip-txt-fracc").on('change', (e) => {
          let fraccionamientoSeleccionado = { Nombre: e.target.value };
          this.funcionConmutadoraDeEventos(fraccionamientoSeleccionado);
      });
    },
    async created() {
      if(this.guardarBusquedaEnLocalStorage) { debugger
        if(this.$store.getters.Get_SINOJ_Fraccionamientos_LocalStorage != null && this.$store.getters.Get_SINOJ_Fraccionamientos_LocalStorage != undefined && this.$store.getters.Get_SINOJ_Fraccionamientos_LocalStorage.length > 0) {
          const BUSCAR_POR_DOMICILIO = (this.parametros.municipioId != null && this.parametros.municipioId != undefined && this.parametros.municipioId > 0)
          this.fraccionamientos = (BUSCAR_POR_DOMICILIO) 
            ? this.$store.getters.Get_SINOJ_Fraccionamientos_LocalStorage.filter(f => f.Municipio.MunicipioId == this.parametros.municipioId)
            : this.$store.getters.Get_SINOJ_Fraccionamientos_LocalStorage;
        }
        else {
          await Promise.resolve(this.obtenerTodosLosFraccionamientosBD({ peticion: { fraccionamientoId: null, municipioId: null, conInactivos: false, esPrueba: false } }));
        }
      }
      else {
        this.cargaCatalogoDeFraccionamientos();
      }
      console.log('entrosCreatedFraccionamientos::',this.$store.getters.Get_SINOJ_Fraccionamientos_LocalStorage);
    },
    listaDeFraccionamientosStorage() {
        return this.$store.getters.Get_SINOJ_Fraccionamientos_LocalStorage;
    },
  }
</script>
<style scoped>
  #id-cat-fracc-sinoj .custom-select{
    background-color: #504f54;
    border: none;
    color: #FFF;
    font-size: 0.9rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Comun/Catalogos/C019Fraccionamientos.vue